const investmentNames = [
  'Large Cap Equity Mutual Funds',
  'Mid Cap Equity Mutual Funds',
  'Small Cap Equity Mutual Funds',
  'Multi-Cap Equity Mutual Funds',
  'Sectoral/Thematic Equity Mutual Funds',
  'Dividend Yield Equity Mutual Funds',
  'Public Provident Fund (PPF)',
  'National Pension System (NPS)',
  'Bank Recurring Deposits (FD)',
  'Bank Fixed Deposits (FD)',
  'Real Estate',
  'Gold',
  'Corporate Bonds',
  'Sovereign Gold Bonds (SGBs)',
  'Government Securities (G-Secs)',
];

export default investmentNames;
